import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useState } from 'react';
export type CopyStatus = 'idle' | 'copied' | 'failed';
const labelKeys = {
  idle: 'copy_code',
  copied: 'copied',
  failed: 'copy_failed'
} as const;
export const useCopyToClipboard = () => {
  const $ = _c(7);
  const t = useTranslations("common");
  const [status, setStatus] = useState("idle");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = async text => {
      try {
        await navigator.clipboard.writeText(text);
        setStatus("copied");
      } catch {
        setStatus("failed");
      }
      setTimeout(() => setStatus("idle"), 2000);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const copy = t0;
  const t1 = labelKeys[status];
  let t2;
  if ($[1] !== t || $[2] !== t1) {
    t2 = t(t1);
    $[1] = t;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== status || $[5] !== t2) {
    t3 = {
      status,
      label: t2,
      copy
    };
    $[4] = status;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};